module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAATZJREFUKBWNUrtKxEAUvXeIf6CI2NnYiGhlJwuClZAuVtqLbEALm212wTQWLplP8A8WrERI8AcUsfEDRIT9AzXXcyZmWdx19cJkZu45J3NfKmPmvd/8MDtT0W0zm1fVoYndRaoXaZreN1TloSiK6OHxqSNiWDLAXoroFoQHxCF+xzdbXlo8T5LkM6KzFlRHprp3mqY39PXzfIE7DeI5fLsvr2+89hxD4gsQHDYCItPNOuQ75gDC4G9B/SL5jknjWk7/86SX/ChUyenzBOxcqVX1w60r4O+jmjpEpqtAb8cZJ+12iTvXyFCcY/B3HPuAcrZGyMyDtsh3bBx48aX3u7P433hMvqs7rZmaXf0mpJ84G0x+aO7G+lqGBguA637u64lQFCfkitBNYhEXJoLRhDFqwvrv7H0BoOyWzyii4lUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/progress-icon.png
// module id = AqSf
// module chunks = 3